import {
  Component,
  computed,
  effect,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ElementType } from '@hyper-inferno/survey-elements-core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { ElementTypeSettings } from '../element-type-settings/element-type-settings';
import { AutoSaveFormBase } from '../base-classes/base-form.class';
@Component({
  selector: 'app-column-configuration-element-settings',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ElementTypeSettings,
    MatSlideToggleModule,
    CommonModule,
  ],
  templateUrl: './column-configuration-element-settings.html',
  styleUrl: './column-configuration-element-settings.scss',
})
export class ColumnConfigurationElementSettings
  extends AutoSaveFormBase<any>
  implements OnInit
{
  override entityName = 'survey_element';
  override entityId = computed(() => this.elementId());
  lastUpdatedName: any;
  protected override rebuildFormArrays(data: any): void {
    /* empty */
  }
  elementId = input.required<number>();
  isLoading = signal(false);
  ElementType = ElementType;
  override form = this.fb.group({
    id: this.fb.control<any | undefined>(undefined),
    question_text: this.fb.control<string | null>(null),
    type: this.fb.control<any | undefined>(undefined),
    name: this.fb.control<any | undefined>(undefined),
    element_type: this.fb.control<ElementType | undefined>(undefined),
    is_variant: this.fb.control(false),
    required: this.fb.control(true),
  });
  currentElementId = signal<number | null>(null);
  constructor() {
    super();
    effect(() => {
      const elementId = this.elementId();
      if (elementId && elementId !== this.currentElementId()) {
        // Element changed
        this.currentElementId.set(elementId);
      }
    });
  }

  override postHydrate(): void {
    //
    this.cdr.detectChanges();
  }
  lastUpdatedText: string | null | undefined;
  isUpdatedRequired: boolean | undefined;

  override ngOnInit() {
    super.ngOnInit();
  }
  override PostCreate(): void {
    const elementId = Number(this.elementId());
    const questionText = this.form.get('question_text')?.value;
    const name = this.form.get('name')?.value; // Extract the name value
    const required = this.form.get('required')?.value;
    // Check if anything has actually changed to prevent redundant API calls
    if (
      this.lastUpdatedText === questionText &&
      this.lastUpdatedName === name &&
      this.isUpdatedRequired === required
    )
      return;

    // Ensure we have the required IDs and data
    if (!elementId || !questionText || !name) return;

    // Update tracking variables
    this.lastUpdatedText = questionText;
    this.lastUpdatedName = name;
    this.isUpdatedRequired = required;
  }
}
